import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

export function createInventoryTranslationRequest(): TranslationRequest {
  return new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
}
